import { motion } from 'framer-motion';

const CompanyHistory = () => {
  const milestones = [
    {
      year: '2024',
      title: 'Foundation',
      description: 'VEDUS Supply Chain Management was established as a small domestic logistics provider in Uttarakhand.'
    },
    {
      year: '2024',
      title: 'National Expansion',
      description: 'Expanded operations to cover all major cities across India with a fleet of 10+ company owned vehicles.'
    },
    {
      year: '2025',
      title: 'International Operations',
      description: 'Launched international shipping services connecting India to global markets.'
    },
    {
      year: '2025',
      title: 'Technology Integration',
      description: 'Implemented advanced tracking systems and AI-powered logistics solutions.'
    },
    {
      year: '2025',
      title: 'Sustainability Initiative',
      description: 'Committed to carbon-neutral operations with investment in electric vehicles and green logistics.'
    }
  ];

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-secondary-900 dark:text-white">Our Journey</h2>
          <p className="text-secondary-600 dark:text-secondary-300">
            VEDUS has been at the forefront of logistics innovation, growing from a small local provider to a global supply chain management leader.
          </p>
        </div>
        
        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-primary-200 dark:bg-primary-800"></div>
          
          {/* Timeline items */}
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <motion.div 
                key={milestone.year}
                className="relative"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className={`md:flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  {/* Year bubble */}
                  <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 items-center justify-center w-12 h-12 rounded-full bg-primary-600 text-white font-bold">
                    {milestone.year}
                  </div>
                  
                  {/* Content */}
                  <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-16 text-right' : 'md:pl-16 text-left'}`}>
                    <div className="bg-white dark:bg-secondary-800 p-6 rounded-lg shadow-md">
                      <div className="md:hidden text-primary-600 dark:text-primary-400 font-bold mb-2">
                        {milestone.year}
                      </div>
                      <h3 className="text-xl font-semibold mb-2 text-secondary-900 dark:text-white">
                        {milestone.title}
                      </h3>
                      <p className="text-secondary-600 dark:text-secondary-300">
                        {milestone.description}
                      </p>
                    </div>
                  </div>
                  
                  {/* Empty div for layout */}
                  <div className="md:w-1/2"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;